import { useEffect } from "react";

import { SESSION_STORAGE_KEYS, syncSessionTokensFromStorage } from "@/lib/auth";
import { sessaoAcabouEmOutraAba } from "@/lib/sessionSync";
import { useAuthStore } from "@/state/authStore";

/**
 * O logout de uma aba atravessa para as outras (F-S5, T-35).
 *
 * Fica **acima do Router**, e não dentro do `ProtectedRoute`: ele era o único
 * ouvinte de sessão, e as rotas públicas (`/v/:slug`, `/public-view/:token`,
 * `/compare`) ficam fora dele — uma aba logada num `/v/{slug}` continuaria
 * mandando o access antigo depois do "Sair" na aba do gerenciador.
 *
 * O evento `storage` **não** dispara na aba que escreveu: a que clicou em
 * "Sair" continua pelo caminho de sempre (`logout` → `clearSessionTokens`).
 * Aqui é só a outra ponta: realinhar a memória desta aba com o storage e, se
 * os dois tokens sumiram, derrubar o estado da tela. Sem redirecionar — a
 * rota protegida navega sozinha para `/login` quando `isAuthenticated` cai, e
 * a pública continua aberta, agora como anônima.
 */
export function SessionAcrossTabs() {
  useEffect(() => {
    const handler = (event: StorageEvent) => {
      const restante = syncSessionTokensFromStorage();
      const mudanca = { key: event.key, newValue: event.newValue };
      if (!sessaoAcabouEmOutraAba(mudanca, restante, SESSION_STORAGE_KEYS)) return;
      const store = useAuthStore.getState();
      if (store.isAuthenticated) store.sessionEndedElsewhere();
    };
    window.addEventListener("storage", handler);
    return () => window.removeEventListener("storage", handler);
  }, []);
  return null;
}
